// extracted by mini-css-extract-plugin
module.exports = {"grid":"ShapesFlyout_grid__3J16p","cell":"ShapesFlyout_cell__2y0Vy"};